import { api, publicApi } from "./api";

// Fire-and-forget instrumentation of browser-side Google activity; each event id is unique, so retries never double count.
const eid = () => Array.from(crypto.getRandomValues(new Uint8Array(12)), (b) => b.toString(16).padStart(2, "0")).join("");

export const trackPublic = (publicId: string, token: string | undefined, event: "map_load" | "place_select") => {
  if (token) publicApi.post(`/public/widgets/${publicId}/track`, { session_token: token, event, event_id: eid() }).catch(() => {});
};

export const trackOrg = (event: "field_map_load" | "lead_map_load" | "field_place_select", leadId?: string) => {
  api.post("/orgs/me/usage/track", { event, event_id: eid(), lead_id: leadId }).catch(() => {});
};
